import {Injectable} from "@angular/core";
import {Loglevel, logLevelValue} from "./loglevel.model";
import {ClientLoggerService} from "./client-logger.service";
import {ServerLoggerService} from "./server-logger.service";
import {BufferLoggerService} from "./buffer-logger.service";
import {setLoggerService} from "./log";
import {LogConfigService} from "./logconfig.service";
import {Router} from "@angular/router";

/**
 * @whatItDoes:
 * Defines what shall be logged on the Client and what reported to the Server
 * Delegates to the adequate Services (ClientLoggerService/ ServerLoggerService / BufferLoggerService) iff appropriate loglevel is configured
 * Store in logBuffer iff SynchronizationMode is OnException and send with Exception.
 */
@Injectable()
export class LoggingService {

  constructor(public config: LogConfigService, private clientLogger: ClientLoggerService, private serverLogger: ServerLoggerService, private bufferLogger: BufferLoggerService, private router: Router) {

  }

  public initializeLogger() {
    setLoggerService(this);
  }

  public doLog(level: Loglevel, message: string, parameters: any[], logToClient = true, include_current_url= true) {
    if (include_current_url) {
      parameters.unshift(this.router.url);
    }
    const entry = {level, message, parameters, stack: undefined};
    if (logToClient && logLevelValue[level] <= logLevelValue[this.config.clientLevel]) {
      this.clientLogger.log(entry);
    }
    if (logLevelValue[level] <= logLevelValue[this.config.serverLevel]) {
      this.logToServer(level, entry);
    }
  }

  private logToServer(level: Loglevel, entry: { level: Loglevel; message: string; parameters: any[]; stack: any }) {
    if (level === "trace") {
      entry.stack = new Error().stack.split('\n').slice(2).join("\n"); // remove our own stack frames
    }
    if (this.config.clientToServerSynchronizationMode === "on_exception") {
      this.bufferLogger.log(entry);
      if (level === "error") {
        this.serverLogger.log(this.bufferLogger.popAll());
      }
    } else {
      entry.message = entry.message.concat("\n" + "Date: "+ new Date().toString() + "\n" + "URL: " + this.router.url);
      this.serverLogger.log([entry]);
    }

  }
}
